(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pending-limit-requests-view', {
            parent: 'entity',
            params:{screen: 'PendingLimitRequestsView'},
            url: '/pending-limit-requests-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.pendingLimitRequestsView.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pending-limit-requests-view/pending-limit-requests-view.html',
                    controller: 'PendingLimitRequestsViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pendingLimitRequestsView');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                systemSetting: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]

            }
        })
        };
    })();
